import 'react'

const DraftIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="7.5"
        fill="#999999"
        stroke="#999999"
      />
      <path d="M11 6.2L9.8 5L6.8 8L8 9.2L11 6.2Z" fill="white" />
      <path d="M5 11L6.8 10.4L5.6 9.2L5 11Z" fill="white" />
      <path
        d="M11 6.2L9.8 5L6.8 8L8 9.2L11 6.2Z"
        stroke="white"
        strokeWidth="1.16667"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5 11L6.8 10.4L5.6 9.2L5 11Z"
        stroke="white"
        strokeWidth="1.16667"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DraftIcon
